<template>
  <div>
    <el-card>

      <div>
        <el-select
          v-model="warehouse"
          placeholder="Warehouse"
          filterable
          clearable
          @change="changeWarehouse"
          size="mini"
          style="margin-right: 10px;">
          <el-option v-for="item in warehouseList"
            :key="item.id"
            :label="item.warehouseName"
            :value="item.id">
          </el-option>
        </el-select>

        <!-- <el-select v-model="vendor" placeholder="Vendor" filterable size="mini" style="margin-right: 10px;">
          <el-option v-for="item in vendorsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            @click.native="setFilter('vendor', item)">
          </el-option>
        </el-select> -->

        <el-date-picker
          popper-class="custom-date-picker"
          size="mini"
          v-model="period"
          :disabled="true"
          @change="changePeriod"
          style="margin-right: 10px;"
          prefix-icon="el-icon-date"
          type="daterange"
          align="center"
          format="d MMM yy"
          value-format="timestamp"
          range-separator=""
          start-placeholder="Start date"
          end-placeholder="End date"
          :picker-options="pickerOptions">
        </el-date-picker>
      </div>

      <el-table
        max-height="650"
        size="mini"
        :data="data"
        :empty-text="$t('general_noData')"
        style="width: 100%; margin-top: 20px;">
        <el-table-column
          prop="warehouseCode"
          label="WHCode"
          width="100">
        </el-table-column>
        <el-table-column
          prop="code"
          label="Item Code"
          width="100">
        </el-table-column>
        <el-table-column
          prop="name"
          label="Item Name"
          width="100">
        </el-table-column>
        <el-table-column
          label="P Description"
          width="120"
          align="center">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.purchaseDescription"
              placement="top"
              title="Description"
              width="400"
              trigger="click"
              :content="scope.row.purchaseDescription">
              <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="S Description"
          width="120"
          align="center">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.sellDescription"
              placement="top"
              title="Description"
              width="400"
              trigger="click"
              :content="scope.row.sellDescription">
              <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="type.name"
          label="Type"
          width="100">
        </el-table-column>
        <el-table-column
          prop="obQty"
          label="OB Qty">
        </el-table-column>
        <el-table-column
          prop="pQty"
          label="P/Qty">
        </el-table-column>
        <el-table-column
          prop="prQty"
          label="P/Return">
        </el-table-column>
        <el-table-column
          prop="sQty"
          label="S/Qty">
        </el-table-column>
        <el-table-column
          prop="srQty"
          label="S/Return">
        </el-table-column>
        <el-table-column
          prop="onHand"
          label="On Hand">
        </el-table-column>
        <el-table-column
          label="P Total"
          align="right">
          <template slot-scope="scope">
            <!-- <div v-if="scope.row.sellPrice" v-text="formatPrice(scope.row.sellPrice)"></div> -->
          </template>
        </el-table-column>
        <el-table-column
          label="S Total"
          align="right">
          <template slot-scope="scope">
            <!-- <div v-if="scope.row.sellPrice" v-text="formatPrice(scope.row.sellPrice)"></div> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="unit.name"
          label="UoM"
          align="center">
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
  import axios from 'axios'
  let moment = require('moment')

  export default {
    name: 'WarehouseItemsReport',
    data() {
      return {
        moment: moment,
        data: [],
        warehouse: null,
        vendor: null,
        period: null,

        warehouseList: [],
        vendorsList: [],

        pickerOptions: {
          shortcuts: [{
            text: 'This month',
            onClick(picker) {
              const end = moment().endOf('month');
              const start = moment().startOf('month');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = moment().endOf('month').subtract(1, 'months');
              const start = moment().startOf('month').subtract(1, 'months');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = moment().endOf('month').subtract(1, 'months');
              const start = moment().startOf('month').subtract(3, 'months');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'This financial quarter',
            onClick(picker) {
              const end = moment().endOf('quarter');
              const start = moment().startOf('quarter');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last financial quarter',
            onClick(picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter');
              const start = moment().subtract(1, 'quarter').startOf('quarter');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'This financial year',
            onClick(picker) {
              const end = moment().endOf('year');
              const start = moment().startOf('year');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last financial year',
            onClick(picker) {
              const end = moment().endOf('year').subtract(1, 'year');
              const start = moment().startOf('year').subtract(1, 'year');
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    methods: {
      async openTab() {
        await this.getWarehouseList()
        await this.getData()
      },
      async getWarehouseList() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.post(`api/v1/inventories/list?companyId=${this.$route.query.companyId}`)
          console.log("🚀 ~ file: CreateUpdateModal.vue:108 ~ directories ~ data:", data)
          this.warehouseList = data.inventoryList
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      async getData() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items-warehouse/list?companyId=${this.$route.query.companyId}&warehouseId=${this.warehouse}`)
          console.log("🚀 ~ file: CreateUpdateModal.vue:108 ~ directories ~ data:", data)
          this.data = data.list
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      changeWarehouse(value) {
        if (value === '') this.warehouse = null
        this.getData()
      },
      changePeriod(value) {
        if (value === null) this.period = null
        this.getData()
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
    },
  }
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  &__label {
    width: 100%;
    height: 170px;
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    text-align: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    color: #606266;
    font-size: 14px;
    z-index: 0;

    &:hover {
      border-color: #409EFF;
    }
    .el-icon-upload {
      display: block;
      font-size: 67px;
      color: #C0C4CC;
      margin: 40px 0 16px;
      line-height: 50px;
    }
    span {
      color: #409EFF;
    }
  }
  &.is-dragover{
    border: 1px dashed #409EFF;
    border-radius: 6px;
    .loading__label{
      background-color:rgba(32,159,255,.06);
    }
  }
}
</style>